import { ourKeys, DataGetters, Values } from "./types";

export default function dataGetters(storage: Values): DataGetters {
  const result = {} as DataGetters;
  ourKeys.forEach(k => {
    (result as any)[k] = () => storage[k];
  });
  return result;
}
